import { SEPARATOR } from './genericName';
import * as libInvestorAccount from './investorAccount';
export const prefix = 'compositions';
export const prefixWithSeparator = prefix + SEPARATOR;
export const IDToName = ({ habitatID, investorID, investorAccountID, investorAccountCompositionID }) => {
    return (libInvestorAccount.IDToName({ habitatID, investorID, investorAccountID }) +
        SEPARATOR +
        prefixWithSeparator +
        investorAccountCompositionID);
};
